export enum EnumRunControlState {
  IDLE = 'idle',
  RUNNING = 'running',
  STOPPING = 'stopping'
}
